import { size } from '@hubble/tokens/web';

const SIZE_MAP = {
  sm: '2px',
  md: size[8],
  lg: size[16]
};

export { SIZE_MAP };
